export default function YoutubeLogo(props: React.ComponentProps<"svg">) {
    return (
        <svg
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g opacity="0.7" clipPath="url(#clip0_1173_3323)">
                <path
                    d="M20.1027 4.3764C20.1027 1.96033 18.1424 0 15.7263 0H4.3764C1.96033 0 0 1.96033 0 4.3764V9.69551C0 12.1116 1.96033 14.0719 4.3764 14.0719H15.7263C18.1424 14.0719 20.1027 12.1116 20.1027 9.69551V4.3764ZM12.9419 7.30441L8.41568 9.78916C8.2159 9.89529 8.04109 9.7517 8.04109 9.52695V4.43259C8.04109 4.20784 8.22214 4.06425 8.42192 4.17662L12.9794 6.79248C13.1792 6.90485 13.1479 7.19828 12.9419 7.31065V7.30441Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_1173_3323">
                    <rect
                        width="20.1027"
                        height="14.0719"
                        fill="currentColor"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}
